<mat-card class="cardWithShadow">
  <mat-card-content style="padding: 36px 36px 0px 36px">
    <mat-card-title>
      <h2>Ver Lista de Platos</h2>
    </mat-card-title>

    <div
      *ngIf="isLoading"
      class="d-flex flex-col flex-wrap align-items-center justify-content-center"
      style="padding-bottom: 36px"
    >
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      <p>Cargando Platos...</p>
    </div>

    <div *ngIf="!isLoading" class="d-flex justify-content-between">
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <input
            matInput
            placeholder="Buscar..."
            (keyup)="applyFilter($event)"
          />
          <mat-icon matSuffix>
            <i-tabler name="search" class="icon-20"></i-tabler>
          </mat-icon>
        </mat-form-field>
      </div>
      <div *ngIf="!isLoading" class="w-100 col-sm-4">
        <button mat-raised-button color="primary" (click)="openDialogAdd()">
          Crear Plato
        </button>
      </div>
    </div>
  </mat-card-content>

  <mat-card-content
    [style.display]="
      !isLoading && dataSource.filteredData.length !== 0 ? 'block' : 'none'
    "
    style="padding: 36px"
  >
    <div class="table-responsive">
      <table
        mat-table
        matSort
        [dataSource]="dataSource"
        class="no-wrap m-t-0 v-middle w-100"
      >
        <ng-container matColumnDef="codigoPlato">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Código
          </th>
          <td mat-cell *matCellDef="let dish" class="f-s-14 custom-column">
            {{ dish?.codigoPlato || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="nombrePlato">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Nombre
          </th>
          <td mat-cell *matCellDef="let dish" class="f-s-14 custom-column">
            {{ dish?.nombrePlato || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="categoria">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Categoría
          </th>
          <td mat-cell *matCellDef="let dish" class="f-s-14 custom-column">
            {{ dish?.categoria || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="observaciones">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
          >
            Observaciones
          </th>
          <td mat-cell *matCellDef="let dish" class="f-s-14 custom-column">
            {{ dish?.observaciones || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="modificar">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="f-w-600 f-s-15 custom-column"
          >
            Editar
          </th>
          <td mat-cell *matCellDef="let dish" class="f-s-14 custom-column">
            <button
              mat-icon-button
              color="primary"
              (click)="navigateToDetallePlato(dish.id)"
            >
              <mat-icon class="icon-color">edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="eliminar">
          <th
            mat-header-cell
            *matHeaderCellDef
            class="f-w-600 f-s-15 custom-column"
          >
            Eliminar
          </th>
          <td
            mat-cell
            *matCellDef="let dish; let i = index"
            class="f-s-14 custom-column"
          >
            <button mat-icon-button (click)="deletePlato(dish)">
              <mat-icon class="icon-color">delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let dish; columns: displayedColumns"></tr>
      </table>
    </div>

    <div *ngIf="!isLoading">
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>
  <div
    *ngIf="!isLoading && dataSource?.filteredData?.length === 0"
    class="d-flex justify-content-center align-items-center"
    style="width: 100%; height: 400px; text-align: center"
  >
    Lo sentimos. No tenemos datos para esta búsqueda.
    <br />Por favor, intenta con otro término.
  </div>
</mat-card>
